import React from 'react';

import css from './ActiveFilters.module.css';
import { IconClose, InlineTextButton, PrimaryButtonInline } from '../../components';
import { array, func, string } from 'prop-types';
import FieldColor from '../FieldColor/FieldColor';
import { FormattedMessage, useIntl } from 'react-intl';

const ActiveFilters = props => {
  const { filters, onSubmit, name, resetAll } = props;
  const intl = useIntl();

  if (!filters || filters.length === 0) {
    return null;
  }

  return (
    <ul className={css.appliedFilters}>
      {filters.map(filter => {
        const { option, label, name: internalName } = filter;
        const fieldName = internalName || name;
        const colorValue = intl.messages[`ListingField.${fieldName}.${option}.swatch`];

        const diplayLabel = colorValue ? (
          <FieldColor label={label} value={colorValue} size={'medium'} />
        ) : (
          label
        );

        return (
          <li key={option}>
            <button
              className={css.appliedFilter}
              onClick={() => onSubmit(name || internalName, option, filter)}
            >
              <span>{diplayLabel}</span>
              <IconClose />
            </button>
          </li>
        );
      })}

      {resetAll && (
        <li key="reset" className={css.resetAll}>
          <InlineTextButton className={css.resetButton} onClick={resetAll}>
            <IconClose />
            <FormattedMessage id="SearchPage.resetAllFilters" />
          </InlineTextButton>
        </li>
      )}
    </ul>
  );
};

ActiveFilters.defaultProps = { filters: [], resetAll: null };

ActiveFilters.propTypes = {
  filters: array.isRequired,
  onSubmit: func.isRequired,
  name: string,
  resetAll: func,
};

export default ActiveFilters;
